import type { FilterEnabledSlugs } from './types';

export const FILTER_ENABLED_SLUGS: FilterEnabledSlugs[] = [
  'cd-rates',
  'investment-apps',
  'bank-bonuses-and-promotions',
];
